<div
  role="tablist"
  class="tw-inline-flex tw-flex-wrap tw-border-0 tw-border-b tw-border-solid tw-border-secondary-300 tw-leading-5"
>
  <ng-content></ng-content>
</div>
